import { QuotationTask, SalesOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1663. 受注案件契約タスク法務チェック済更新
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:id/update_legal_checked
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  legal_checked: boolean;
};

const updateSalesOrderContractLegalChecked = (props: Props): Promise<SalesOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.id}/update_legal_checked`,
    props
  );
};

export const useUpdateSalesOrderContractLegalChecked = () => {
  return useMutation({
    mutationFn: updateSalesOrderContractLegalChecked,
  });
};
